/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import Section from "../Section/Section";
import Video from "../Video/Video";
import { Trans } from "@lingui/macro";
import { graphql } from "~/gql";

export default function EventVideos({ videos, ...rest }) {
  if (!hasContent({ videos })) return null;
  const needsTitle = !videos[0]?.title;
  return (
    <Section title={needsTitle && <Trans>Videos</Trans>} {...rest}>
      {videos.map((video) => (
        <Video key={video?.videoId} {...video} />
      ))}
    </Section>
  );
}
EventVideos.hasContent = hasContent;
function hasContent(event) {
  if (!event?.videos?.length) return false;
  return event.videos.some((video) => Video.hasContent(video));
}

export const fragment = graphql(`
  fragment bb_EventVideos on Bottlebooks_Video {
    type
    videoId
    title
    ...bb_Video
  }
`);

export const EventVideosFragment = gql`
  fragment bb_EventVideos on Video {
    type
    videoId
    title
    ...Video
  }

  ${Video.fragment}
`;
